import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { formatMoneda, validaMonto, validaSoloNumero } from "../../util/varios";
import CatalogoCatProgramatica from "../../catalogos/catalogoCategoriaProgramatica";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaClasificadorPartidasExtras from "./tablaClasificadorPExtras";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";
import { Input, Radio, Textarea } from "../../ui/inputs/Input";
export const PartidasExtras = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const anioefis = JSON.parse(localStorage.getItem("efiscalanio"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [mostrar3, setMostrar3] = useState(false);
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState(0);
  const [val, setVal] = useState(0.0);
  const [val2, setVal2] = useState(0.0);
  const [idcat, setIdcat] = useState(0);
  const [idpc, setIdpc] = useState(0);
  const [cat, setCat] = useState(0);
  const [pucc, setPucc] = useState(0);
  const [puccd, setPuccd] = useState(0);
  const [idpucd, setIdpucd] = useState(0);
  const [codigo, setCodigo] = useState(0);
  const [proyecto, setProyecto] = useState(0);
  const [actiiva, setActiiva] = useState(true);
  const [data, setData] = useState([]);
  const [chek, setChek] = useState(1);
  const [body, setBody] = useState(null);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const [categorias, setCategorias] = useState({
    txt6: "",
    txt7: "",
    txt8: "",
    txt9: "",
    txtDescriclas: "",
    txtMontoClass: "",
  });
  const btnAcepta = useRef();
  const txtIdd = useRef();
  const txtFecha = useRef();
  const txtOrdinario = useRef();
  const txtInstitucion = useRef();
  const txtFci = useRef();
  const txtFides = useRef();
  const txtLae = useRef();
  const txtBandes = useRef();
  const txtObservacion = useRef();
  const txtSi = useRef();
  const txtNo = useRef();
  const btnCat = useRef();
  const txtDescriclas = useRef();
  const txtDescriaux = useRef();
  const txtMonto = useRef();
  const txtAuxiliar = useRef();
  const txtDescriubi = useRef();
  const txtMontoClass = useRef();
  const txtNp = useRef();
  const txtSarep = useRef();
  const txtPropios = useRef();
  const txt1 = useRef();
  const txt2 = useRef();
  const txt3 = useRef();
  const txt4 = useRef();
  const txt5 = useRef();
  const txt6 = useRef();
  const txt7 = useRef();
  const txt8 = useRef();
  const txt9 = useRef();

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const onCheck = () => {
    // let sigue = false;

    if (txtSi.current.checked) {
      /* let monto = txtMonto.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", "."); */
      //seleccionarClassific(monto);

      setChek(1);
      calcularIva();
      //sigue = true;
    } else if (txtNo.current.checked) {
      let mont = txtMontoClass.current.value.trim().replace(/\./g, "").replace(",", ".");
      let monto = txtMonto.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      let total = 0.0;
      console.log(0);

      total = parseFloat(monto) - parseFloat(mont);
      txtMonto.current.value = formatMoneda(
        total.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );

      /* setCategorias({
        txt6: "",
        txt7: "",
        txt8: "",
        txt9: "",
        txtDescriclas: "",
        txtMontoClass: "",
      }); */
      setChek(0);
      //sigue = true;
      txt6.current.value = "";
      txt7.current.value = "";
      txt8.current.value = "";
      txt9.current.value = "";
      txtDescriclas.current.value = "";
      txtMontoClass.current.value = "";
      total = parseFloat(monto) - parseFloat(mont);
      txtMonto.current.value = formatMoneda(
        total.toString().replace(",", "").replace(".", ","),
        ",",
        ".",
        2
      );
      setPuccd(0);
      setIdpucd(0);
      setVal(0.0);
    }

    /*    if (sigue) {
               let mont = txtMontoClass.current.value.trim().replace(/\./g, '').replace(',', '.');
               if (txtSi.current.checked) {
                   let monto = txtMonto.current.value.trim().replace(/\./g, '').replace(',', '.');
                   seleccionarClassific(monto);
                   console.log(1);
               } else if (txtNo.current.checked) {
                   let monto = txtMonto.current.value.trim().replace(/\./g, '').replace(',', '.');
                   let total = 0.00;
                   console.log(0);
   
                   txt6.current.value = "";
                   txt7.current.value = "";
                   txt8.current.value = "";
                   txt9.current.value = "";
                   txtDescriclas.current.value = "";
                   txtMontoClass.current.value = "";
   
                   total = parseFloat(monto) - parseFloat(mont);
                   txtMonto.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
               }
           } */
  };

  const calcularIva = () => {
    let monto = txtMonto.current.value
      .trim()
      .replace(/\./g, "")
      .replace(",", ".");
    seleccionarClassific(monto);
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (new Date(txtFecha.current.value).getFullYear() !== anioefis) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (
      txtOrdinario.current.checked === false &&
      txtInstitucion.current.checked === false &&
      txtFci.current.checked === false &&
      txtFides.current.checked === false &&
      txtLae.current.checked === false &&
      txtBandes.current.checked === false &&
      txtSarep.current.checked === false &&
      txtPropios.current.checked === false
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Tipo",
        icono: "informacion",
      });
      sigue = false;
      txtOrdinario.current.focus();
    } else if (
      txtSi.current.checked === false &&
      txtNo.current.checked === false
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el IVA",
        icono: "informacion",
      });
      sigue = false;
      txtSi.current.focus();
    } else if (txt1.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Categoria Programatica",
        icono: "informacion",
      });
      sigue = false;
      btnCat.current.focus();
    } else if (txtDescriaux.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Cuenta",
        icono: "informacion",
      });
      sigue = false;
      txtDescriaux.current.focus();
    } /*  else if (txtDescriubi.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Describa la Ubicación', icono: 'informacion' });
            sigue = false;
            txtDescriubi.current.focus();
        } */ else if (txtAuxiliar.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Auxiliar no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtAuxiliar.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Clasificador Presupuestario",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      let datos = [];
      let dataiva = [];
      if (operacion === 1) {
        for (let e = 0; e < data.length; e++) {
          datos.push({
            m_cCat: cat.trim(),
            m_cCta: data[e].puc,
            m_cAux: txtAuxiliar.current.value.trim(),
            m_cDescAux: txtDescriaux.current.value.trim(),
            m_nMontoInicial: data[e].monto
              .trim()
              .replace(/\./g, "")
              .replace(",", "."),
            m_nEfiscal: idefiscal,
            m_nIdCatPro: parseInt(idcat),
            m_nIdPuc: parseInt(data[e].id),
            m_cSecgeo: txtDescriubi.current.value.trim(),
            m_nTippar: 1,
            m_nTipCue: txtOrdinario.current.checked
              ? 1
              : txtInstitucion.current.checked
                ? 4
                : txtFci.current.checked
                  ? 5
                  : txtFides.current.checked
                    ? 2
                    : txtLae.current.checked
                      ? 3
                      : txtBandes.current.checked
                        ? 6
                        : txtSarep.current.checked
                          ? 7
                          : 8,
            adic: txtSi.current.checked ? 1 : 0,
            obser: txtObservacion.current.value.trim(),
            m_proy: proyecto,
            m_recu: 0,
            m_gace: "",
            m_extr: "",
            m_fech: txtFecha.current.value.trim(),
            m_cCon: 0,
            m_usu: parseInt(idusuario),
            m_capit: 0.0,
            m_corri: 0.0,
            m_financ: 0.0,
            m_inv: 0,
            m_clas: "NA",
            m_cod: codigo,
          });
        }
        if (txtSi.current.checked) {
          dataiva.push({
            m_cCat: cat.trim(),
            m_cCta: puccd,
            m_cAux: txtAuxiliar.current.value.trim(),
            m_cDescAux: txtDescriclas.current.value.trim(),
            m_nMontoInicial: val,
            m_nEfiscal: idefiscal,
            m_nIdCatPro: parseInt(idcat),
            m_nIdPuc: parseInt(idpucd),
            m_cSecgeo: txtDescriubi.current.value.trim(),
            m_nTippar: 1,
            m_nTipCue: txtOrdinario.current.checked
              ? 1
              : txtInstitucion.current.checked
                ? 4
                : txtFci.current.checked
                  ? 5
                  : txtFides.current.checked
                    ? 2
                    : txtLae.current.checked
                      ? 3
                      : txtBandes.current.checked
                        ? 6
                        : txtSarep.current.checked
                          ? 7
                          : 8,
            adic: 1,
            obser: txtObservacion.current.value.trim(),
            m_proy: proyecto,
            m_recu: 0,
            m_gace: "",
            m_extr: "",
            m_fech: txtFecha.current.value.trim(),
            m_cCon: "00",
            m_usu: parseInt(idusuario),
            m_capit: 0.0,
            m_corri: 0.0,
            m_financ: 0.0,
            m_inv: 0,
            m_clas: "NA",
            m_cod: codigo,
          });
        }
      } else if (operacion === 2) {
        for (let e = 0; e < datospre.length; e++) {
          datos.push({
            m_cCat: props.presu.categoria.trim(),
            m_cCta: datospre[e].puc,
            m_cAux: txtAuxiliar.current.value.trim(),
            m_cDescAux: txtDescriaux.current.value.trim(),
            m_nEfiscal: props.presu.idefiscal,
            m_nIdCatPro: parseInt(props.presu.idcategoriaprogramatica),
            m_nIdPuc: parseInt(datospre[e].idpuc),
          });
        }
        if (txtSi.current.checked) {
          dataiva.push({
            m_cCat: props.presu.categoria.trim(),
            m_cCta: props.class.puc.trim(),
            m_cAux: txtAuxiliar.current.value.trim(),
            m_cDescAux: txtDescriaux.current.value.trim(),
            m_nEfiscal: props.presu.idefiscal,
            m_nIdCatPro: parseInt(props.presu.idcategoriaprogramatica),
            m_nIdPuc: parseInt(props.class.idpuc),
          });
        }
      } else if (operacion === 3) {
        for (let e = 0; e < datospre.length; e++) {
          datos.push({
            m_fech: txtFecha.current.value.trim(),
            obser: txtObservacion.current.value.trim(),
            m_proy: proyecto,
          });
        }

      }

      setBody({
        operacion: operacion,
        movimientos: datos,
        iva: dataiva,
        idf: idefiscal,
      });
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Reversar esta Cuenta?.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Editar esta Cuenta?.";
      }
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/crearpartidasextras`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Partida Extra Registrado Correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Partida Extra Reversado Correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Partida Extra Modificada Correctamente",
              icono: "exito",
            });
          }
          setOperacion(0);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setChek(1);
    setValida(0);
    setVal(0.0);
    setVal2(0.0);
    setCat(0);
    setPucc(0);
    setPuccd(0);
    setIdcat(0);
    setIdpc(0);
    setIdpucd(0);
    setCodigo(0);
    txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
    setData([]);
    setActiiva(true);
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacion === 2) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacion === 3) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const catalogoCat = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
      if (event.target.value.length === 1) {
        txtAuxiliar.current.value = "000" + event.target.value;
      } else if (event.target.value.length === 2) {
        txtAuxiliar.current.value = "00" + event.target.value;
      } else if (event.target.value.length === 3) {
        txtAuxiliar.current.value = "0" + event.target.value;
      } else if (event.target.value.length === "") {
        txtAuxiliar.current.value = "0000";
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    if (event.which === 13) {
      if (event.target.id === "monto") {
        txtMonto.current.focus();
      } else if (event.target.id === "montoclas") {
        txtMontoClass.current.focus();
      }
    }

    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");
    return formatMoneda(e);
  };

  const handleAceptaCatProgramatica = (
    idcategoriaprogramatica,
    descripcion,
    categoriaprogramatica
  ) => {
    setMostrar3(false);
    txt1.current.value = categoriaprogramatica.substring(0, 2);
    txt2.current.value = categoriaprogramatica.substring(2, 4);
    txt3.current.value = categoriaprogramatica.substring(4, 6);
    txt4.current.value = categoriaprogramatica.substring(6, 8);
    txt5.current.value = categoriaprogramatica.substring(8, 10);
    setCat(categoriaprogramatica);
    setIdcat(idcategoriaprogramatica);
  };

  const handleCancelara = () => {
    setMostrar3(false);
  };

  const BaseDatos = (data) => {
    let mont = 0.0;
    if (data.length > 0) {
      setValida(data[0].id);
      setPucc(data[0].puc);
      setIdpc(data[0].id);
      setData(data);
      for (let i = 0; i < data.length; i++) {
        mont =
          parseFloat(mont) +
          parseFloat(data[i].monto.trim().replace(/\./g, "").replace(",", "."));
      }
      if (txtSi.current.checked) {
        let monto = mont;
        seleccionarClassific(monto);
      }
    } else {
      setValida(0);
      setPucc(0);
      setIdpc(0);
      setData([]);
      setPuccd(0);
      setIdpucd(0);
      if (txtSi.current.checked) {
        txtMontoClass.current.value = "0,00";
      }


    }

    let total = formatMoneda(
      mont.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    txtMonto.current.value = formatMoneda(
      mont.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );
    setVal2(total.trim().replace(/\./g, "").replace(",", "."));
    /*if (data[0].id > 0) {
      setActiiva(false);
    }*/
    console.log(total);
  };

  const SeleccionarSequencia = () => {
    let endpoint = `${op.conexion}/api/presupuesto/sequencia`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setProyecto(response.data.numproyect);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarClassific = (monto) => {
    setActivate(true);
    let campos = "puc, trim(descripcion)  AS descripcion, idpuc";
    let nomtab = "puc";
    let nomid = "idefiscal";
    let condic;
    if (
      espiritu < 7 ||
      espiritu === 9 ||
      espiritu === 12 ||
      espiritu === 13 ||
      espiritu === 14
    ) {
      condic = "puc = '403180100'";
    } else {
      condic = "puc = '403180102'";
    }
    let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txt6.current.value = response.data[0].puc.substring(0, 3);
          txt7.current.value = response.data[0].puc.substring(3, 5);
          txt8.current.value = response.data[0].puc.substring(5, 7);
          txt9.current.value = response.data[0].puc.substring(7, 9);
          txtDescriclas.current.value = response.data[0].descripcion;
          setPuccd(response.data[0].puc);
          setIdpucd(response.data[0].idpuc);
          let total = 0.0;
          let mont = txtMonto.current.value
            .trim()
            .replace(/\./g, "")
            .replace(",", ".");
          let totalmonto = 0.0;
          total = (parseFloat(monto) * 16) / 100;
          totalmonto = parseFloat(mont) + total;
          /* setCategorias({
            txt6: response.data[0].puc.substring(0, 3),
            txt7: response.data[0].puc.substring(3, 5),
            txt8: response.data[0].puc.substring(5, 7),
            txt9: response.data[0].puc.substring(7, 9),
            txtDescriclas: response.data[0].descripcion,
            txtMontoClass: formatMoneda(
              total.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            ),
          }); */

          /* txt6.current.value = response.data[0].puc.substring(0, 3);
                txt7.current.value = response.data[0].puc.substring(3, 5);
                txt8.current.value = response.data[0].puc.substring(5, 7);
                txt9.current.value = response.data[0].puc.substring(7, 9); 
                txtDescriclas.current.value = response.data[0].descripcion;
                 txtMontoClass.current.value = formatMoneda(total.toString().replace(',', '').replace('.', ','), ',', '.', 2);
          setPuccd(response.data[0].puc);
          setIdpucd(response.data[0].idpuc);*/

          setVal(total);
          txtMontoClass.current.value = formatMoneda(
            total.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          txtMonto.current.value = formatMoneda(
            totalmonto.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );

          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarCodigo = () => {
    let endpoint = `${op.conexion}/api/presupuesto/ultimocodigo?idefiscal=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let codigo = response.data.codigo;
          let count = codigo + 1;
          setCodigo(count);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        //SeleccionarSequencia();
        //SeleccionarCodigo();
        if (props.operacion !== 1) {
          setActiiva(true);
          setValues(props.presu);
          setDatospre(props.presutabla);
          setValida(props.presu.idcuenta);
          setProyecto(props.presu.proyecto);
          txtFecha.current.value = moment.utc(props.presu.fechagaceta).format("YYYY-MM-DD");
          if (props.class.idcuenta > 0) {
            let monto = 0.0;
            let montoclass = props.class.disponibilidad;
            let total = 0.0;

            for (let i = 0; i < props.presutabla.length; i++) {
              monto =
                parseFloat(monto) +
                parseFloat(props.presutabla[i].disponibilidad);
            }
            console.log(monto);
            total = parseFloat(monto) + parseFloat(montoclass);
            txtMonto.current.value = formatMoneda(
              total.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );

            if ((props.class.puc = "403180100")) {
              txtSi.current.checked = true;
              txtNo.current.checked = false;
              setChek(1);
            } else {
              setChek(0);
              txtNo.current.checked = true;
              txtSi.current.checked = false;
            }
            if (txtSi.current.checked) {
              txt6.current.value = props.class.puc.substring(0, 3);
              txt7.current.value = props.class.puc.substring(3, 5);
              txt8.current.value = props.class.puc.substring(5, 7);
              txt9.current.value = props.class.puc.substring(7, 9);
              txtDescriclas.current.value = props.class.descripcion;
              txtMontoClass.current.value = formatMoneda(
                props.class.montoinicial
                  .toString()
                  .replace(",", "")
                  .replace(".", ","),
                ",",
                ".",
                2
              );
            }

          } else {
            let monto = 0.0;
            for (let i = 0; i < props.presutabla.length; i++) {
              monto =
                parseFloat(monto) +
                parseFloat(props.presutabla[i].disponibilidad);
            }
            txtMonto.current.value = formatMoneda(
              monto.toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
            setChek(0);
            txtNo.current.checked = true;
          }
        } else {
          setActiiva(false);
          setChek(0);
          txtSi.current.checked = false;
          txtNo.current.checked = true;
          txtOrdinario.current.checked = true;

          txtFci.current.checked = false;
          txtDescriaux.current.value = "";
          txtDescriubi.current.value = "";

          txtAuxiliar.current.value = "0000";
          txt1.current.value = "";
          txt2.current.value = "";
          txt3.current.value = "";
          txt4.current.value = "";
          txt5.current.value = "";
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD")
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Crear Partidas Extras."
              : operacion === 2
                ? "Reversar Partidas Extras."
                : "Consultar Partidas Extras."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <CatalogoCatProgramatica
          show={mostrar3}
          onHideCancelar={handleCancelara}
          onHideAceptaCatProgramatica={handleAceptaCatProgramatica}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-12 m-0 p-0">
          <input type="hidden" ref={txtNp} />
          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap 
            justify-content-between align-items-center
            border-azul rounded">
            <legend className="float-none m-0 w-auto">Datos</legend>
            <input
              type="hidden"
              className="form-control"
              disabled={true}
              ref={txtIdd}
              aria-label="Sizing example input"
              aria-describedby="1inputGroup-sizing-sm"
              value={values ? values.idcuenta.trim() : ""}
              id="inputCedula"
            />

            <div className="col-5 m-0 p-0">
              <Input label='Fecha de Resolución:'
                type="date"
                disabled={
                  operacion === 4 || operacion === 2 ? true : deshabilitado
                }

                id="inputDireccion"
                ref={txtFecha}
              />
            </div>

            <fieldset className="col-4 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none m-0 w-auto">
                Posee IVA
              </legend>
              <div className="col-6 m-0 p-0">
                <Radio label='SI'
                  disabled={actiiva}
                  type="radio"
                  onChange={onCheck}
                  name="radioIva"
                  id="exampleRadiosdos1"
                  value="option1"
                  ref={txtSi}
                />
              </div>
              <div className="col-6 m-0 p-0">
                <Radio label='NO'
                  disabled={actiiva}
                  type="radio"
                  onChange={onCheck}
                  value="option2"
                  name="radioIva"
                  id="exampleRadiosdos2"
                  ref={txtNo}
                />
              </div>
            </fieldset>

            <fieldset className="col-12 m-0 mt-2 p-2 border-azul rounded">
              <legend className="float-none m-0 w-auto">Tipo</legend>
              <div className="row mx-0 px-0">
                <div className="col-md-3">
                  <Radio
                    label="Ingresos Ordinarios"
                    disabled={operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado}
                    defaultChecked={props.presu?.tipocuenta === 1}
                    name="exampleRadiosuno"
                    id="exampleRadiosuno1"
                    value="option1"
                    ref={txtOrdinario}
                  />
                </div>
                <div className="col-md-2">
                  <Radio
                    label="Institucion"
                    disabled={operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado}
                    defaultChecked={props.presu?.tipocuenta === 4}
                    name="exampleRadiosuno"
                    id="exampleRadiosuno4"
                    value="option4"
                    ref={txtInstitucion}
                  />
                </div>
                <div className="col-md-2">
                  <Radio
                    label="FCI"
                    disabled={operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado}
                    defaultChecked={props.presu?.tipocuenta === 5}
                    name="exampleRadiosuno"
                    id="exampleRadiosuno5"
                    value="option5"
                    ref={txtFci}
                  />
                </div>
                {/* <div className="col-md-3">
                  <Radio
                    label="Fides"
                    disabled={operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado}
                    defaultChecked={props.presu?.tipocuenta === 2}
                    name="exampleRadiosuno"
                    id="exampleRadiosuno2"
                    value="option2"
                    ref={txtFides}
                  />
                </div> 
                <div className="col-md-12">
                  <div className="dropdown-divider"></div>
                </div>
                <div className="col-md-3">
                  <Radio
                    label="LAE"
                    disabled={operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado}
                    defaultChecked={props.presu?.tipocuenta === 3}
                    name="exampleRadiosuno"
                    id="exampleRadiosuno3"
                    value="option3"
                    ref={txtLae}
                  />
                </div>
                <div className="col-md-3">
                  <Radio
                    label="Bandes"
                    disabled={operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado}
                    defaultChecked={props.presu?.tipocuenta === 6}
                    name="exampleRadiosuno"
                    id="exampleRadiosuno6"
                    value="option6"
                    ref={txtBandes}
                  />
                </div> */}
                <div className="col-md-2">
                  <Radio
                    label="Sarep"
                    disabled={operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado}
                    defaultChecked={props.presu?.tipocuenta === 7}
                    name="exampleRadiosuno"
                    id="exampleRadiosuno7"
                    value="option7"
                    ref={txtSarep}
                  />
                </div>
                <div className="col-md-3">
                  <Radio
                    label="Ingresos propios"
                    disabled={operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado}
                    defaultChecked={props.presu?.tipocuenta === 8}
                    name="exampleRadiosuno"
                    id="exampleRadiosuno8"
                    value="option8"
                    ref={txtPropios}
                  />
                </div>
              </div>
            </fieldset>

          </fieldset>

          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-end border-azul rounded">
            <legend className="float-none m-0 w-auto">
              Categoria Programatica
            </legend>
            <div className="col-md-12 mx-auto row mb-1">
              <table class="col-11 table table-responsive px-0 border">
                <thead>
                  <tr>
                    <th className="text-center" scope="col">
                      Sector
                    </th>
                    <th className="text-center" scope="col">
                      Prog
                    </th>
                    <th className="text-center" scope="col">
                      SubProg
                    </th>
                    <th className="text-center" scope="col">
                      Proy
                    </th>
                    <th className="text-center" scope="col">
                      Act
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input
                        type="text"
                        disabled={true}
                        maxLength="2"
                        name="uno"
                        ref={txt1}
                        onChange={onChange}
                        onChangeCapture={handleInputNumChange}
                        defaultValue={
                          props.presu
                            ? props.presu.categoria.substring(0, 2)
                            : ""
                        }
                        className="form-control text-uppercase mr-1 text-center"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputLogin"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        disabled={true}
                        maxLength="2"
                        name="dos"
                        ref={txt2}
                        onChange={onChange}
                        onChangeCapture={handleInputNumChange}
                        defaultValue={
                          props.presu
                            ? props.presu.categoria.substring(2, 4)
                            : ""
                        }
                        className="form-control text-uppercase mr-1 text-center"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputLogin"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        disabled={true}
                        maxLength="2"
                        name="tres"
                        ref={txt3}
                        onChange={onChange}
                        onChangeCapture={handleInputNumChange}
                        defaultValue={
                          props.presu
                            ? props.presu.categoria.substring(4, 6)
                            : ""
                        }
                        className="form-control text-uppercase mr-1 text-center"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputLogin"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        disabled={true}
                        maxLength="2"
                        name="cuatro"
                        ref={txt4}
                        onChange={onChange}
                        onChangeCapture={handleInputNumChange}
                        defaultValue={
                          props.presu
                            ? props.presu.categoria.substring(6, 8)
                            : ""
                        }
                        className="form-control text-uppercase mr-1 text-center"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputLogin"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        disabled={true}
                        maxLength="2"
                        name="cinco"
                        ref={txt5}
                        onChange={onChange}
                        onChangeCapture={handleInputNumChange}
                        defaultValue={
                          props.presu
                            ? props.presu.categoria.substring(8, 10)
                            : ""
                        }
                        className="form-control text-uppercase text-center"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputLogin"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="col d-flex">
                <button
                  disabled={
                    operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado
                  }
                  ref={btnCat}
                  onClick={catalogoCat}
                  className="btn btn-sm  btn-info my-auto mx-auto rounded-circle"
                >
                  <i className="fa fa-search"></i>{" "}
                </button>
              </div>


            </div>

            <div className="col-3 m-0 mb-2 p-0">
              <Input label='Ordinal N°:'
                maxLength="4"
                disabled={
                  operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado
                }
                onBlur={handleInputNumChange}
                onKeyUp={handleInputNumChange}
                name="nproyecto"
                defaultValue={props.presu ? props.presu.auxiliar : "0000"}
                id="inputLogin"
                ref={txtAuxiliar}
              />
            </div>
            <div className="col-md-12 row mx-auto px-0">

              <div className="col-6 m-0 mb-2 p-0">
                <Textarea label='Descripción de la Cuenta'
                  style={{ height: 50 }}
                  onChangeCapture={onChange}
                  name="descriaux"
                  disabled={
                    operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado
                  }
                  defaultValue={props.presu ? props.presu.descripcionaux : ""}
                  placeholder="Descripción de la cuenta"
                  id="inputDireccion"
                  ref={txtDescriaux}
                />
              </div>
              <div className="col-6 m-0 p-0">
                <Textarea label='Ubicación Geografica'
                  style={{ height: 50 }}
                  onChangeCapture={onChange}
                  name="ubicacion"
                  disabled={
                    operacion === 4 || operacion === 2 || operacion === 3 ? true : deshabilitado
                  }
                  defaultValue={props.presu ? props.presu.sectorgeog : ""}
                  id="inputDireccion"
                  ref={txtDescriubi}
                />
              </div>
            </div>
          </fieldset>

          <fieldset className="row border-azul rounded mx-auto">
            <legend className="float-none m-0 w-auto">
              Clasificador Presupuestario
            </legend>

            <div className="col-md-12 px-0">
              <TablaClasificadorPartidasExtras
                modal="partidasextras"
                data={BaseDatos}
                datarecords={datospre}
                operacion={operacion}
              />
            </div>
          </fieldset>

          {chek === 1 ? (
            <fieldset className="row border-azul rounded mx-auto">
              <legend className="float-none m-0 w-auto">
                Clasificador Presupuestario IVA
              </legend>

              <div className="input-group input-group-sm col-md-7 mb-1">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Ramo:
                </label>
                <input
                  type="text"
                  disabled={true}
                  maxLength="3"
                  name="uno"
                  ref={txt6}
                  onChange={onChange}
                  onChangeCapture={handleInputNumChange}
                  className="form-control text-uppercase mr-1"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputLogin"
                />

                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Gen:
                </label>
                <input
                  type="text"
                  disabled={true}
                  maxLength="2"
                  name="dos"
                  ref={txt7}
                  onChange={onChange}
                  onChangeCapture={handleInputNumChange}
                  className="form-control text-uppercase mr-1"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputLogin"
                />

                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Espec:
                </label>
                <input
                  type="text"
                  disabled={true}
                  maxLength="2"
                  name="tres"
                  ref={txt8}
                  onChange={onChange}
                  onChangeCapture={handleInputNumChange}
                  className="form-control text-uppercase mr-1"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputLogin"
                />

                <label className="input-group-text" id="inputGroup-sizing-sm">
                  SubEsp:
                </label>
                <input
                  type="text"
                  disabled={true}
                  maxLength="2"
                  name="cuatro"
                  ref={txt9}
                  onChange={onChange}
                  onChangeCapture={handleInputNumChange}
                  className="form-control text-uppercase mr-1"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputLogin"
                />
              </div>

              <div className="col-md-5"></div>

              <div className="input-group input-group-sm col-md-12 mb-1">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Descripción:
                </label>
                <textarea
                  type="textarea"
                  style={{ height: 50 }}
                  className="form-control text-uppercase"
                  disabled={true}
                  value={categorias.txtDescriclas}
                  ref={txtDescriclas}
                  placeholder="Descripción del Clasificador Presupuestario"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputDireccion"
                />
              </div>

              <div className="col-md-8"></div>
              <div className="input-group input-group-sm col-md-4 mb-1">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Monto IVA:
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  disabled
                  className="form-control text-right"
                  ref={txtMontoClass}
                  onBlur={handleInputMontoChange}
                  onKeyUp={handleInputMontoChange}
                  placeholder="0,00"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="montoclas"
                />
              </div>
            </fieldset>
          ) : (
            ""
          )}

          <div className="col-12 m-0 mt-2 p-0">
            <Textarea label='Observaciones'
              style={{ height: 50 }}
              name="observacion"
              onChange={onChange}
              disabled={
                operacion === 4 || operacion === 2 ? true : deshabilitado
              }
              defaultValue={props.presu ? props.presu.observacion : ""}
              id="inputDireccion"
              ref={txtObservacion}
            />
          </div>
          <div className="col-4 m-0 mt-2 ml-auto p-0">
            <Input label='Monto Total:'
              type="text"
              autoComplete="off"
              className="form-control text-right bg-transparent"
              disabled={true}
              ref={txtMonto}
              onBlur={handleInputMontoChange}
              onKeyUp={handleInputMontoChange}
              placeholder="0,00"
              aria-label="Sizing example input"
              aria-describedby="inputGroup-sizing-sm"
              id="monto"
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
